
<div [ngClass]="styles.countdownContainer" *ngIf="showBroadcastCountdown">

	<div [ngClass]="styles.countdownMsg">
		<vb-centered-spinner [msg]="countdownSecs" [msgDisplayBelowSpinner]="true"></vb-centered-spinner>
	</div>

</div>

<ng-template #unhandledError>
	<div class="container-fluid">
		<div class="row padding-top-10">
			<div class="col-xs-12" [ngClass]="styles.border">
				<div class="centered-copy">
					<div class="alert alert-danger">
						{{ 'UnhandledError' | translate }}
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<div class="resize-fill" layout="column" layout-wrap="false" *ngIf="!error; else unhandledError">

	<div layout="column" layout-gt-md="row" flex="fill" flex-wrap="false">
		<div [ngClass]="styles.playerWrap" [vbWatchDimensions]="[playerRef]" [padding]="32" *ngIf="displayCaptureStream">
			<video #playerRef autoplay [muted]="true" [srcObject]="displayCaptureStream">
			</video>
		</div>
		<div [ngClass]="styles.playerWrap" [vbWatchDimensions]="[playerRef]" [padding]="32" *ngIf="speakerStream">

			<video #playerRef autoplay [muted]="true" [srcObject]="speakerStream">
			</video>
		</div>
		<div [ngClass]="styles.playerWrap" *ngIf="!speakerStream && !displayCaptureStream" [vbWatchDimensions]="[imgRef]">
			<div #imgRef [ngClass]="styles.placeholder">
				<img [attr.src]="'/img/placeholder-2.svg'"/>
				<div>{{'Capture_Header' | translate}}</div>
			</div>
		</div>
	</div>

	<div [ngClass]="styles.toolbar">

		<ng-container *ngIf="!isMobile">
			<div [ngClass]="styles.toolbarGroup">
				<button vbBtnPrimary (click)="startCapture()">
					<span class="vb-icon vb-icon-center vb-icon-share" [ngClass]="displayCaptureStream ? 'text-success': ''"></span>
					{{ (displayCaptureStream ? 'Event_Capture_ChangeScreen' : 'Event_Capture_ShareScreen') | translate }}
				</button>
			</div>

			<div [ngClass]="styles.toolbarGroup" *ngIf="displayCaptureStream">
				<button vbBtnPrimary (click)="stopCapture()">
					<span class="glyphicons retweat"></span>
					{{ 'Event_Capture_StopShare' | translate }}
				</button>
			</div>
		</ng-container>

		<div [ngClass]="styles.toolbarGroup">
			<div class="btn-group" dropdown [dropup]="true">
				<button type="button" vbBtnPrimary (click)="setCamera(!cameraEnabled, lastSelectedCamera)">
					{{ (cameraEnabled ? 'Event_SelfProduced_StopCam' : 'Event_SelfProduced_StartCam') | translate }}
				</button>

				<button type="button" dropdownToggle vbBtnPrimary class="dropdown-toggle dropdown-toggle-split" *ngIf="cameraDevices">
					<span class="caret"></span>
					<span class="visually-hidden">{{'Event_SelfProduced_ChooseCam' | translate}}</span>
				</button>

				<ul *dropdownMenu class="dropdown-menu theme-primary" role="menu" aria-labelledby="button-split">
					<li role="menuitem">
						<button type="button" class="dropdown-item theme-primary" (click)="setCamera(true)">
							{{'Capture_ChooseCameraAutomatically' | translate}}
						</button>
					</li>
					<li role="menuitem" *ngFor="let device of cameraDevices">
						<button type="button" class="dropdown-item theme-primary" (click)="setCamera(true, device)">
							{{ device.label }}
						</button>
					</li>
				</ul>
			</div>

			<div [ngClass]="styles.deviceLabel" [attr.title]="selectedCameraLabel">
				{{ selectedCameraLabel }}
			</div>
		</div>

		<div [ngClass]="styles.toolbarGroup">
			<div class="btn-group" dropdown vbDropdown [dropup]="true">
				<button type="button" vbBtnPrimary (click)="toggleMic()">
					{{ ((micEnabled && micStream) ?
						'Event_SelfProduced_Mute' :
						(micStream ? 'Event_SelfProduced_Unmute' : 'Event_SelfProduced_StartMic')) | translate
					}}
				</button>

				<button type="button" dropdownToggle vbBtnPrimary class="dropdown-toggle dropdown-toggle-split" *ngIf="micDevices">
					<span class="caret"></span>
					<span class="visually-hidden">{{'Event_SelfProduced_ChooseMic' | translate}}</span>
				</button>

				<ul *dropdownMenu class="dropdown-menu theme-primary" role="menu" aria-labelledby="button-split">
					<li role="menuitem">
						<button type="button" class="dropdown-item theme-primary" (click)="setMic(true)">
							{{'Capture_ChooseMicAutomatically' | translate}}
						</button>
					</li>
					<li role="menuitem" *ngFor="let device of micDevices">
						<button type="button" class="dropdown-item theme-primary" (click)="setMic(true, device)">
							{{ device.label }}
						</button>
					</li>
				</ul>
			</div>

			<div [ngClass]="styles.deviceLabel" [attr.title]="selectedMicLabel">
				{{ selectedMicLabel }}
			</div>
		</div>
	</div>
</div>
